import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CacheRouteReuseStrategy implements RouteReuseStrategy {
	private storedRoutes = new Map<string, DetachedRouteHandle>();

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return !!route.routeConfig?.data?.['cache'];
	}

	store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
		const path = getResolvedUrl(route);
		this.storedRoutes.set(path, handle);
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		const path = getResolvedUrl(route);
		return !!this.storedRoutes.get(path);
	}

	retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
		const path = getResolvedUrl(route);
		return this.storedRoutes.get(path)!;
	}

	shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		return future.routeConfig === curr.routeConfig;
	}
}

const getResolvedUrl = (route: ActivatedRouteSnapshot) => {
	const retVal = route.pathFromRoot
		.filter((x) => x.url.length > 0)
		.map((v) => v.url.map((segment) => segment.toString()).join('/'))
		.join('/');
	return retVal;
};
